module.exports = __webpack_public_path__ + "static/media/tesla_blink.6361f189.jpg";